<template>
    <div v-if="lead">
        <v-toolbar flat color="blue" dark>
            <v-toolbar-title>{{lead.lastName}}</v-toolbar-title>
            <v-spacer></v-spacer>


        </v-toolbar>
        <v-container fluid>
            <v-row>
                <v-col cols="8">
                    <v-card color="mb-2">
                        <v-toolbar flat >
                            <v-toolbar-title>Contact Details</v-toolbar-title>
                        </v-toolbar>
                        <v-list>
                            <v-list-item>
                                <v-list-item-icon>
                                    <v-icon
                                            color="blue"
                                    >
                                        mdi-account
                                    </v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                    <v-list-item-title>{{lead.lastName}}</v-list-item-title>
                                    <v-list-item-subtitle>{{lead.title}}</v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item>
                                <v-list-item-icon>
                                    <v-icon
                                            color="blue"
                                    >
                                        mdi-mail
                                    </v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                    <v-list-item-title>
                                        {{lead.email}}
                                        <v-chip v-if="lead.contactBy === 'email'" color="green" dark small>Preferred</v-chip>
                                    </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item>
                                <v-list-item-icon>
                                    <v-icon
                                            color="blue"
                                    >
                                        mdi-phone
                                    </v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                    <v-list-item-title>
                                        {{lead.phoneWork}}
                                        <v-chip v-if="lead.contactBy === 'phone'" color="green" dark small>Preferred</v-chip>
                                    </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                    </v-card>
                </v-col>
                <v-col cols="4">
                    <v-card color="mb-2" >
                        <v-toolbar flat >
                            <v-toolbar-title>Zoho Details</v-toolbar-title>
<v-spacer/>
                            <v-btn
                                    v-if="lead.zohoId"
                                    :href="createZohoLink(lead.zohoId)"
                                    target="_blank"
                                    color="primary"
                            >View in Zoho
                            </v-btn>
                        </v-toolbar>
                        <v-list  v-if="lead.zohoId">
                            <v-list-item >
                                <v-list-item-icon>
                                    <v-icon
                                            color="blue"
                                    >
                                        mdi-file
                                    </v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                    <v-list-item-title>{{lead.zohoId}}</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item v-if="lead.zohoMessage">
                                <v-list-item-icon>
                                    <v-icon
                                            color="blue"
                                    >
                                        mdi-message
                                    </v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                    <v-list-item-title>{{lead.zohoMessage}}</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item v-if="lead.zohoCreatedAt">
                                <v-list-item-icon>
                                    <v-icon
                                            color="blue"
                                    >
                                        mdi-clock
                                    </v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                    <v-list-item-title>{{lead.zohoCreatedAt}}</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                        <v-card-text v-else>
                            <p>Not transferred to Zoho</p>
                            <v-btn
                                target="_blank"
                                color="primary"
                                :disabled="transferringToZoho"
                                @click="transferToZoho(lead.id)"
                            >Transfer to Zoho
                            </v-btn>
                        </v-card-text>

                    </v-card>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">

                    <v-card color="mb-2">
                        <v-toolbar flat >
                            <v-toolbar-title>Lead Details</v-toolbar-title>
                        </v-toolbar>
                        <v-list>
                            <v-list-item v-if="lead.leadSource">
                                <v-list-item-icon>
                                    <v-icon
                                            color="blue"
                                    >
                                        mdi-source-branch
                                    </v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                    <v-list-item-title>{{lead.leadSource}}
                                        <v-chip v-if="lead.clientType" color="indigo" dark small>{{lead.clientType}}</v-chip>
                                    </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item v-if="lead.course">
                                <v-list-item-icon>
                                    <v-icon
                                            color="blue"
                                    >
                                        mdi-tag
                                    </v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                    <v-list-item-title>{{lead.course.title}}</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item v-if="lead.timescale">
                                <v-list-item-icon>
                                    <v-icon
                                            color="blue"
                                    >
                                        mdi-clock
                                    </v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                    <v-list-item-title>{{lead.timescale}}</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item v-if="lead.delegates">
                                <v-list-item-icon>
                                    <v-icon
                                            color="blue"
                                    >
                                        mdi-account-multiple
                                    </v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                    <v-list-item-title>{{lead.delegates}}</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item v-if="lead.trainingLocation">
                                <v-list-item-icon>
                                    <v-icon
                                            color="blue"
                                    >
                                        mdi-pin
                                    </v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                    <v-list-item-title>{{lead.trainingLocation}}</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item v-if="lead.description">
                                <v-list-item-icon>
                                    <v-icon
                                            color="blue"
                                    >
                                        mdi-message
                                    </v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                    <v-textarea
                                            v-model="lead.description"
                                            rows="10"
                                            class="ma-0 pa-0"
                                    />
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                    </v-card>

                </v-col>
            </v-row>


        </v-container>
    </div>
</template>

<script>
    import LEAD_GET from "../graphql/Leads/Get.gql";
    import ZohoMixin from "../mixins/ZohoMixin";
    import TRANSFER_LEAD_TO_ZOHO from "../graphql/Leads/TransferLeadToZoho.gql";

    export default {
        mixins: [ZohoMixin],
        data() {
            return {
                transferringToZoho: false
            }
        },
        apollo: {
            lead: {
                query: LEAD_GET,
                variables() {
                    return {
                        id: parseInt(this.$route.params.id)
                    }
                },
                update: data => data.lead
            },
        },
        methods: {
            transferToZoho(leadId) {
                this.transferringToZoho = true
                this.$apollo.mutate({
                    mutation: TRANSFER_LEAD_TO_ZOHO,
                    variables: {leadId: leadId},
                }).then((result) => {
                    console.log(result)
                    this.transferringToZoho = false
                    if(result.data.transferLeadToZoho.status === 'SUCCESS') {
                        this.$store.dispatch('notification/addSuccess', 'Lead Transferred Successfully')
                        this.lead.zohoId = result.data.transferLeadToZoho.zohoId
                    }else{
                        this.$store.dispatch('notification/handleGraphQlError',  result.data.transferLeadToZoho.message)
                    }
                })
            }
        },
    }
</script>

<style scoped>

</style>